<div [ngClass]="{'controller-container':isController}" class="container" *ngIf="isCradleOnline; else bellOfflineMsg">
  <app-notification-bar></app-notification-bar>
  <div class="title" *ngIf="!isController">
    <span>Carol Bells</span>
  </div>
  <mat-card class="section" >
    <mat-card-content class="action-items">


      <!-- <div class="actions" *ngFor="let pattern of ringPatterns">
        <button mat-fab extended (click)="dispatchAction(
            CradleCommands.RING,
            pattern.id
          )"
          [disabled]="cradleStatus.isRinging">
          <mat-icon><span class="material-icons">
            {{pattern.icon}}
            </span></mat-icon>
          {{pattern.name}}
        </button>
      </div> -->
      <div class="actions" *ngIf="!isController">
        <button mat-fab extended (click)="dispatchAction(CradleCommands.STOP,0)" [ngClass]="{stopColor:bellStatus.isRinging}">
          <mat-icon>notifications_off</mat-icon>
          Stop
        </button>
      </div>
      <div class="actions" *ngIf="!isController">
        <button mat-fab extended (click)="dispatchAction(CradleCommands.EMERGENCY_STOP,0)" class="stopColor">
          <mat-icon>notifications_off</mat-icon>
          Emergency Stop
        </button>
      </div>
    <div *ngIf="bellStatus?.isRinging" class="ringing-notification">
      <span style="color:red; margin-right:10px;"><mat-icon>circle_notifications</mat-icon></span>
      <span>
        <span>Bell Ringing</span>
        <span *ngIf="bellStatus.patternId"> in {{ringPatternsDict[bellStatus.patternId]?.name}} pattern</span>
        <span *ngIf="bellStatus.scheduleId"> as scheduled</span>
      </span>
    </div>
      <div class="pattern-btn-container">
          <app-ring-btn class="button-card" [pattern]="pattern" *ngFor="let pattern of paginatedRingPatterns"
            (triggerRing)="dispatchAction(CradleCommands.RING,$event)"></app-ring-btn>
      </div>

      <!-- <div class="actions" >
        <button mat-fab extended (click)="refreshScreen()">
          <mat-icon><span class="material-icons">
            refresh
            </span></mat-icon>
        </button>
      </div> -->
      <div class="actions" *ngIf="!isController">
        <button mat-fab extended (click)="dispatchAction(CradleCommands.STOP,0)" [ngClass]="{stopColor:bellStatus.isRinging}">
          <mat-icon>notifications_off</mat-icon>
          Stop
        </button>
      </div>

      <!-- <div class="actions">
        <button mat-fab extended (click)="cradleService.dispatchCommand(
            CradleCommands.CUTSOM_RING,
            9,
            [1,1,3]
          )"
          [ngClass]="{stopColor:cradleStatus.isRinging}">
          <mat-icon><span class="material-icons">
            <span class="material-icons">
              local_hospital
              </span>
            </span></mat-icon>
          Kurishu Mani
        </button>
      </div>
      <div class="actions">
        <button mat-fab extended (click)="cradleService.dispatchCommand(
            CradleCommands.RING,
            99,
            0.4
          )"
          [ngClass]="{stopColor:cradleStatus.isRinging}">
          <mat-icon><span class="material-icons">
            <span class="material-icons">
              festival
              </span>
            </span></mat-icon>
          Festival Continous
        </button>
      </div> -->
    </mat-card-content>
  </mat-card>

</div>
<div class="bottom-panel" *ngIf="isController">
  <button mat-fab extended (click)="onPagePrevious()" [disabled]="this.currentPage<=0">
    <mat-icon>arrow_back_ios</mat-icon>
    Previous
  </button>
  <app-lock-button [style]="{margin: '0px 10px'}"></app-lock-button>

  <button mat-fab extended (click)="dispatchAction(CradleCommands.STOP,0)" [ngClass]="{stopColor:bellStatus.isRinging}" class="lg-btn">
    <mat-icon>notifications_off</mat-icon>
    Stop
  </button>
    <button mat-stroked-button color="warn" (click)="dispatchAction(CradleCommands.EMERGENCY_STOP,0)" class="stopColor emergency-stop-btn">
      Emergency Stop
    </button>
    <button mat-fab [routerLink]="['/schedule-rings']" style="width: 60px">
      <mat-icon>alarm</mat-icon>
    </button>

  <button mat-fab extended (click)="onPageNext()" [disabled]="this.currentPage>=this.lastPage">
    Next
    <mat-icon>arrow_forward_ios</mat-icon>
  </button>
</div>

<ng-template #bellOfflineMsg>
  <mat-card class="section">
    <mat-card-header class="center-align"><strong>Bell Offline</strong></mat-card-header>
    <mat-card-content class="action-items">
      <span class="center-align"
        >Bell is not connected. Please turn on bell or connect it to
        internet.</span
      >
      <br/>
      <br/>
      <button mat-fab extended (click)="refreshScreen()">
        <mat-icon>refresh</mat-icon>
        Refresh Status
      </button>
    </mat-card-content>
  </mat-card>
</ng-template>
